import { flatMap, flow, map, uniq } from "lodash-es";

const getClassroomSubjectsList = (classrooms = []) => {
  const applyTo =
    (target) =>
    (...fns) =>
      flow(fns)(target);
  const applier =
    (lodashFn) =>
    (...args) =>
    (target) =>
      lodashFn(target, ...args);

  const classroomSubjects = applyTo(classrooms)(
    applier(flatMap)(function (classroom) {
      return classroom.subjects;
    }),
    applier(map)(function (subject) {
      return subject.slug;
    }),
    applier(uniq)(),
  );

  return classroomSubjects;
};

export default getClassroomSubjectsList;
